export enum bomFeatureText {
  HERO_TITLE = "Bill of Materials (BOM) - Smarter Costing, Structured for Growth",
  HERO_DESCRIPTION = `At Ease Margin, our Bill of Materials (BOM) solution does more than just list materials — it visually builds your entire product structure with precision, clarity, and real-time cost control.
  \nWhether you’re creating simple items or complex products with multiple layers of sub-assemblies, our BOM tool empowers you to manage single-level and multi-level BOMs with an intuitive tree structure that brings your product to life. `,

  HERO_BUTTON = "Get Started for Free",

  INTRO_TITLE = "What is BOM?",
  INTRO_DESCRIPTION = `A Bill of Materials (BOM) is a complete roadmap of everything needed to manufacture a product — from raw materials and components to labor, processes, and additional costs.
  At Ease Margin, we take BOM a step further by offering multi-level BOMs with a dynamic tree structure, making it easier to visualize, manage, and optimize even the most complex assemblies.`,

  DASHBOARD_TITLE = "📊 Why Ease Margin’s BOM Stands Out",
  BOM_TITLE = "📊 Who is BOM For?",
  BOM_BUILD_TITLE = "Build Smarter. Plan Faster. Grow Stronger.",

  GLANCE_TITLE = "Key Benefits at a Glance",
  REAL_TIME_TITLE = "Real-Time Costing Made Simple",
  ML_BOM_TITLE = "Why Multi-Level BOM Matters",

  UN_BOM_DESC = "Multi-level BOMs aren’t just nested lists — they're a clear, visual tree that shows the parent-child relationships between components, sub-assemblies, and final products.",
  BOM_DESC = "Whether you’re a manufacturer, product designer, procurement manager, or cost estimator, Ease Margin’s BOM gives you the structure, accuracy, and flexibility to scale your production and protect your profits.",
  BOM_BUILD_DESC = "With Ease Margin’s BOM, you can visualize your entire product structure, track costs with precision, and optimize your margins confidently. From simple products to multi-layered assemblies, we help you build success from the ground up.",
  FT_BOM_DESC = "Your BOM automatically updates as prices fluctuate, giving you instant, reliable cost projections and full margin visibility.",
  CTA_TITLE = "🚀 Get Started Today – Bring Your BOM to Life.",
  CTA_BUTTON = "Contact Us for a Free Demo",
}

export const bomDashboardFeatures = [
  "Instantly see how each part connects",
  "Quickly trace material flows and dependencies",
  "Effortlessly manage complex product hierarchies ",
];

export const glanceDesc = [
  "Build Single & Multi-Level BOMs with Visual Clarity",
  "Track Raw Material, Process, and Overhead Costs in Real Time",
  "Dynamically Adjust Costs as Prices Change",
  "Accurately Estimate Manufacturing Costs & Profit Margins",
  "Streamline Procurement and Production Planning",
];

export const realTimeFeature = [
  "Raw materials",
  "Processes & labor",
  "Sub-assemblies",
  "Additional expenses",
];

export const multiBOMFeature = [
  "Break down complex assemblies step by step",
  "Track costs at each production stage",
  "Easily manage changes across components",
  "Improve version control and product traceability",
];
